module.exports = __webpack_public_path__ + "static/media/dinner.6b2aee08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dinner.svg
// module id = 948
// module chunks = 5